import { Route, Routes } from 'react-router-dom';
import { Companies, SuperProfile, SuperDashboardPage, AnalyticsPage, SalesPage, Reports, DesignDocsPage, DiscoveryTemplatePage } from '../pages/superAdmin';
import { Dashboard, ResetPassword } from '../pages/admin';
import SuperUserPage from '../pages/super/users/page';
import Constants from '../Constants';

const SuperAdminRoutes = () => {
    return <Routes>
            <Route path='dashboard' element={<SuperDashboardPage />}/>
            <Route path='sales' element={<SalesPage />}/>
            <Route path='analytics' element={<AnalyticsPage />}/>
            <Route path="reports" element={<Reports />} />
            {!Constants.isDiscoveryHidden && <Route path='discoveryTemplate' element={<DiscoveryTemplatePage/>}/>}
            <Route path="companies" element={<Companies />} />
            <Route path="users" element={<SuperUserPage />} />
            <Route path="design" element={<DesignDocsPage />} />
            <Route path="profile" element={<SuperProfile />} />
        <Route path="forgot-password" element={<ResetPassword />} />
        <Route path="firm-dashboard/:firm" element={<Dashboard />} />

        {/* <Route path="pdf-converter" element={<PdfConverter />} /> */}
    </Routes>
}

export default SuperAdminRoutes;